<div class="show-for-medium">
  <button [matMenuTriggerFor]="accountMenu" class="dropdown__button light-color" data-cy="account-dropdown-button">
    <rav-icon [name]="RavIcon.Person" class="dropdown__icon--small"></rav-icon>
    {{ localStorage.userWithToken?.first_name }} {{ localStorage.userWithToken?.last_name }}
  </button>

  <mat-menu #accountMenu="matMenu">
    <div class="dropdown__menu grid-y grid-padding-x">
      <h4 class="cell padding-top-1">
        {{ localStorage.userWithToken?.first_name }} {{ localStorage.userWithToken?.last_name }}
      </h4>
      <p class="cell">Account ID: {{ user.account_id }}</p>
      <mat-divider></mat-divider>
      <button class="dropdown__button cell flex-container align-middle margin-vertical-1" (click)="launchAccount()">
        <span class="dropdown__icon padding-right-1"><rav-icon name="person-o"></rav-icon></span>
        My Account
      </button>
      <a
        *ngIf="!router.url.includes('/admin')"
        class="dropdown__button cell flex-container align-middle margin-bottom-1"
        routerLink="/contacts"
      >
        <span class="dropdown__icon padding-right-1"><rav-icon [name]="RavIcon.Contacts"></rav-icon></span>
        Contacts
      </a>
      <button
        *ngIf="!router.url.includes('/admin')"
        class="dropdown__button cell flex-container align-middle margin-bottom-1"
        (click)="onHelpClick()"
        data-cy="account-help"
      >
        <span class="dropdown__icon padding-right-1">
          <rav-icon name="question-mark"></rav-icon>
        </span>
        Help
      </button>
      <a
        *ngIf="!router.url.includes('/admin')"
        target="_blank"
        class="dropdown__button cell flex-container align-middle margin-bottom-1"
        href="https://www.raven.com/pages/raven-scanner"
      >
        <span class="dropdown__icon padding-right-1">
          <rav-icon [name]="RavIcon.ShoppingCart"></rav-icon>
        </span>
        Shop
      </a>
      <button
        class="dropdown__button cell flex-container align-middle margin-bottom-1"
        (click)="logout()"
        data-cy="account-sign-out"
      >
        <span class="dropdown__icon padding-right-1"><rav-icon name="power-off"></rav-icon></span>
        Sign Out
      </button>
    </div>
  </mat-menu>
</div>
